import { getPremiumPageDiscount, isValidDiscount } from "../login/auth_utils"

/**
 * @returns generic one line component with go to premium button
 */
function GenericPremiumOneLineComponent({ discount = getPremiumPageDiscount() }) {
  // console.log("discount object "+JSON.stringify(discount))
  if (!isValidDiscount(discount)) return (<span></span>)

  return (
    <div className="flex w-full justify-center px-3 pt-7 pb-2">
      <a
        href="/premium"
        className="
          group inline-flex max-w-full items-center justify-center gap-2
          rounded-full border border-orange-100 bg-orange-50/70
          px-4 py-2 text-sm font-sans font-semibold
          text-slate-500 shadow-sm shadow-orange-100/50
          transition-all duration-200
          hover:-translate-y-0.5 hover:border-orange-200 hover:bg-orange-100/80
          hover:text-slate-700 hover:shadow-md hover:shadow-orange-100
          focus:outline-none focus:ring-2 focus:ring-orange-200 focus:ring-offset-2
        "
      >
        <span
          className="
            inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full
            bg-white text-orange-600 shadow-sm ring-1 ring-orange-100
            transition duration-200 group-hover:bg-orange-600 group-hover:text-white
          "
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            className="h-4 w-4"
          >
            <path
              d="M5 18h14"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M5.5 16.5 4.6 8l4.8 3.2L12 5l2.6 6.2L19.4 8l-.9 8.5h-13Z"
              fill="currentColor"
            />
          </svg>
        </span>

        <span className="flex min-w-0 flex-wrap items-center justify-center gap-x-2 gap-y-1 leading-6">
          <span className="text-slate-400 group-hover:text-slate-600">
            {discount.oneLineDescription}
          </span>

          {discount.discountPercentage > 0 &&
            <span
              className="
                rounded-full bg-white px-2.5 py-0.5
                text-base font-extrabold text-orange-600
                ring-1 ring-orange-100
                transition duration-200 group-hover:bg-orange-600 group-hover:text-white
              "
            >
              {discount.discountPercentage}% off
            </span>
          }

          {discount && discount.timeLeftString && discount.timeLeftString.length > 0 &&
            <span className="text-xs font-semibold text-slate-400 group-hover:text-slate-500">
              {discount.timeLeftString}
            </span>
          }

          <span className="text-orange-500 transition duration-200 group-hover:translate-x-0.5">
            →
          </span>
        </span>
      </a>
    </div>
  )
}

export {GenericPremiumOneLineComponent,}